<script setup lang="ts">
import NovaLabel from "@/ui-kit/NovaLabel/NovaLabel.vue";
import NovaInputText from "@/ui-kit/NovaInputText/NovaInputText.vue";
const { $t } = useNuxtApp();

interface Props {
  offerName: string;
  offerTitle: string | undefined;
  error?: string;
  readonly?: boolean;
}

const props = defineProps<Props>();
const modelValue = defineModel<string>();
</script>

<template>
  <div class="bg-white border border-gray-300 rounded-lg p-4 shadow-xs">
    <h2 v-if="props.offerTitle" class="text-sm font-semibold mb-4">{{ props.offerTitle }}</h2>

    <div class="grid grid-cols-2 gap-4">
      <div class="flex flex-col">
        <div class="mb-2">
          <NovaLabel theme="middle-grey">{{ $t("option-names.current") }}</NovaLabel>
        </div>
        <div class="bg-white border border-gray-300 rounded-lg p-4 shadow-xs flex-1">
          <NovaInputText :model-value="props.offerName" :readonly="true">
            <slot name="diff" />
          </NovaInputText>
        </div>
      </div>
      <div class="flex flex-col">
        <div class="mb-2">
          <NovaLabel theme="teal-green">{{ $t("option-names.commercial") }}</NovaLabel>
        </div>
        <div class="bg-white border border-gray-300 rounded-lg p-4 shadow-xs flex-1">
          <NovaInputText v-model="modelValue" :readonly="props.readonly" show-metrics :error="props.error" />
        </div>
      </div>
    </div>
  </div>
</template>
